import React, { useState } from 'react';
import DataRow from './DataRow';

const DataRows = ({
    definitions,
    data,
    rowIds,
    maxVisibleRows,
    newlyCreated: newItem,
    onActionClick,
    onFavouriteClick,
    primaryColumn,
    onPrimaryColumnClick,
    onActionIconLoad,
    onActionToolTip,
    onCustomClick,
    scrollPxH,
    scrollPxV,
    onScroll,
    dateFormat,
    timeFormat,
    locale,
    currency,
    maxVisibleLength,
    scrollableLength,
    gutterOffset,
    onSizeChange,
    onKeyPress,
    onTick,
    actionIconSize,
    rowHeight,
    selectedDeleteRows,
    addToDelete,
    highlightOnClick,
    onCustomCellStyle
}) => {
    const [highlightedRow, setHightlightedRow] = useState(-1);
    const [highlightedIdx, setHighlightedIdx] = useState(-1);

    let dataset = [...data];
    if (newItem) {
        const filteredData = data.filter((d) => d.id !== newItem.id);
        dataset = [newItem, ...filteredData];
    }
    const maxRows = maxVisibleRows || (dataset.length === 16 ? 16 : 15);
    const emptyRows = [];

    const fillEmptyRows = () => {
        let startIndex = dataset.length;
        for (let i = 0, len = maxRows - dataset.length; i < len; i++) {
            emptyRows.push(
                <DataRow
                    key={`emptyrow${i}`}
                    definitions={definitions}
                    index={startIndex++}
                    scrollPxH={scrollPxH}
                    scrollPxV={scrollPxV}
                    rowHeight={rowHeight}
                    maxVisibleRows={maxVisibleRows}
                    // note that no data passed to create empty rows
                />
            );
        }

        return emptyRows;
    };

    return (
        <tbody>
            {dataset.map((d, i) => (
                <DataRow
                    key={`${d.id}(${i})` || `datarow${i}`}
                    rowKey={`datarow${i}`}
                    rowIds={rowIds}
                    definitions={definitions}
                    data={d}
                    index={i}
                    onActionClick={onActionClick}
                    onFavouriteClick={onFavouriteClick}
                    primaryColumn={primaryColumn}
                    onPrimaryColumnClick={onPrimaryColumnClick}
                    onActionIconLoad={onActionIconLoad}
                    onActionToolTip={onActionToolTip}
                    onCustomClick={onCustomClick}
                    scrollPxH={scrollPxH}
                    isHighlighted={highlightedRow === i}
                    onHover={setHightlightedRow}
                    dateFormat={dateFormat}
                    timeFormat={timeFormat}
                    locale={locale}
                    currency={currency}
                    scrollPxV={scrollPxV}
                    onScroll={onScroll}
                    scrollableLength={rowHeight * dataset?.length}
                    maxVisibleLength={rowHeight * maxVisibleRows}
                    gutterOffset={gutterOffset}
                    onSizeChange={onSizeChange}
                    onKeyPress={onKeyPress}
                    onTick={onTick}
                    actionIconSize={actionIconSize}
                    rowHeight={rowHeight}
                    maxVisibleRows={maxVisibleRows}
                    deleteRowSelected={
                        selectedDeleteRows?.filter((s) => s?.id === d?.id)
                            ?.length > 0
                    }
                    addToDelete={addToDelete}
                    highlightedIdx={highlightedIdx}
                    setHighlightedIdx={setHighlightedIdx}
                    highlightOnClick={highlightOnClick}
                    onCustomCellStyle={onCustomCellStyle}
                />
            ))}
            {fillEmptyRows()}
        </tbody>
    );
};

export default DataRows;
